<template>
  <div class="register">
    <Header />
    <div class="register-header">
      <b-container class="register-header-container">
        <b-row class="register-header-row">
          <div class="col-lg-12 col-md-6">
            <div class="register-header">
              <h1>Formulir Pembukaan Rekening Nasabah</h1>
              <p>Mohon isi data berikut agar Anda bisa memulai investasi.</p>
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
    <div class="register-form">
      <b-container class="register-form-container">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Identitas Diri</h1>
                <p>Personal Identity</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Email</h3>
                <p>Email</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="user.individual.email"
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>No. Telepon</h3>
                <p>Mobile Phone</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="user.individual.mobile_phone"
                  disabled
                />
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Nama Sesuai KTP</h3>
                <p>Full Name according your ID</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  @change="fillName"
                  v-model="first_name"
                  required
                  name="first_name"
                />
                <div class="error mt-3" v-if="!$v.first_name.required">
                  <p>Wajib diisi</p>
                </div>
                <div class="error mt-3" v-if="!$v.first_name.minLength">
                  <p>
                    Nama harus memiliki setidaknya
                    {{ $v.first_name.$params.minLength.min }} karakter.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Kewarganegaraan</h3>
                <p>Nationality</p>
                <vs-select
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="country_code"
                  name="country_code"
                  id="country_code"
                  style="width: 100%"
                >
                  <vs-select-item
                    :key="index"
                    :value="country.country_code"
                    :text="country.country_name"
                    v-for="(country, index) in countryList"
                  />
                </vs-select>
              </div>
              <div class="error mt-3" v-if="!$v.country_code.required">
                <p>Wajib diisi</p>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-radio">
                <h3>Dokumen Identitas</h3>
                <p>ID Document</p>
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <vs-radio
                      v-model="id_type"
                      vs-name="KTP"
                      vs-value="1"
                      @change="checkId"
                      >KTP<span> / ID Card</span></vs-radio
                    >
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <vs-radio
                      v-model="id_type"
                      vs-name="Paspor"
                      vs-value="2"
                      @change="unCheckId"
                      >Paspor<span> / Pasport</span></vs-radio
                    >
                  </div>
                </div>
                <div class="error mt-3" v-if="!$v.id_type.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Nomor ID</h3>
                <p>ID Number</p>
                <div v-if="id_type === '1'">
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="no_id"
                    required
                  />
                </div>
                <div v-else-if="id_type === '2'">
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="text"
                    v-model="no_id"
                    required
                    name="no_id"
                  />
                </div>
                <div class="error mt-3" v-if="!$v.no_id.required">
                  <p>Wajib diisi</p>
                </div>
                <div class="error mt-3" v-if="!$v.no_id.minLength">
                  <div v-if="id_type === '2'">
                    <div v-if="no_id.length < 9">
                      <p>Nomer ID harus memiliki setidaknya 9 karakter.</p>
                    </div>
                  </div>
                  <div v-else>
                    <p>
                      Nomer ID harus memiliki setidaknya
                      {{ $v.no_id.$params.minLength.min }} karakter.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </b-row>

          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <div v-show="id_type === '2'">
                  <h3>Tanggal Kadaluarsa Paspor</h3>
                  <p>Pasport Expired Date</p>
                  <date-picker
                    style="height: 38px"
                    v-model="expiration_date_id"
                    valueType="format"
                    format="YYYY-MM-DD"
                  ></date-picker>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Tempat Lahir</h3>
                <p>Place of Birth</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="place_of_birth"
                  required
                  name="place_of_birth"
                />
                <div class="error mt-3" v-if="!$v.place_of_birth.required">
                  <p>Wajib diisi</p>
                </div>
                <div class="error mt-3" v-if="!$v.place_of_birth.minLength">
                  <p>
                    Tempat lahir harus memiliki setidaknya
                    {{ $v.place_of_birth.$params.minLength.min }} karakter.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Tanggal Lahir</h3>
                <p>Date of Birth</p>
                <b-input-group class="mb-3">
                  <date-picker
                    v-model="date_of_birth"
                    valueType="format"
                    format="YYYY-MM-DD"
                    required
                    name="date_of_birth"
                  ></date-picker>
                </b-input-group>
                <div class="error mt-3" v-if="!$v.date_of_birth.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-5 col-md-6">
              <div class="ekyc-form-radio">
                <h3>Jenis Kelamin</h3>
                <p>Gender</p>
                <b-row>
                  <div class="col-lg-6 col-md-6">
                    <vs-radio
                      v-model="id_gender"
                      vs-name="Laki-Laki"
                      vs-value="1"
                      >Laki-Laki<span> / Male</span></vs-radio
                    >
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <vs-radio
                      v-model="id_gender"
                      vs-name="Perempuan"
                      vs-value="2"
                      >Perempuan<span> / Female</span></vs-radio
                    >
                  </div>
                </b-row>
                <div class="error mt-3" v-if="!$v.id_gender.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-radio">
                <h3>Status Pernikahan</h3>
                <p>Marital Status</p>
                <b-row>
                  <div class="col-lg-3 col-md-6">
                    <vs-radio
                      v-model="id_marital_status"
                      vs-name="Lajang"
                      vs-value="1"
                      >Lajang <span> / Single</span></vs-radio
                    >
                  </div>
                  <div class="col-lg-3 col-md-6">
                    <vs-radio
                      v-model="id_marital_status"
                      vs-name="Menikah"
                      vs-value="2"
                      >Menikah<span> / Married</span></vs-radio
                    >
                  </div>
                  <div class="col-lg-3 col-md-6">
                    <vs-radio
                      v-model="id_marital_status"
                      vs-name="Janda"
                      vs-value="3"
                      >Janda/Duda<span> / Divorce</span></vs-radio
                    >
                  </div>
                </b-row>
                <div class="error mt-3" v-if="!$v.id_marital_status.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <!-- spouse & children -->
    <b-row class="justify-content-md-start mb-4">
      <div class="col-lg-3 col-md-6"></div>			      
      <div class="col-lg-4 col-md-6">
        <div class="ekyc-form-input">
          <h3>Nama Pasangan</h3>
          <!-- <p>Spouse Name</p> -->
          <div>            
            <input v-model="spouse_name" class="mb-2 mr-sm-2 mb-sm-0 form-control"
            name="spouse_name">
          </div>           
          <div v-if="id_marital_status == '2'">              
            <div class="error mt-3" v-if="!$v.spouse_name.required">
              <p>Wajib diisi</p>
            </div>                    
          </div>       
        </div>
      </div>      
      <div class="col-lg-4 col-md-6">
        <div class="ekyc-form-input">
          <h3>Nama Ibu</h3>
          <!-- <p>Number od Children</p> -->
          <div>           
            <input type="text" v-model="mother_name" class="mb-2 mr-sm-2 mb-sm-0 form-control"
            name="mother_name">
          </div>                           
          <div class="error mt-3" v-if="!$v.mother_name.required">
            <p>Wajib diisi</p>
          </div>            
        </div>
      </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Agama</h3>
                <p>Religion</p>
                <vs-select class="selectExample" v-model="id_religion" required>
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in religionList"
                  />
                </vs-select>
                <div class="error mt-3" v-if="!$v.id_religion.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Pendidikan Terakhir</h3>
                <p>Last Education</p>
                <vs-select
                  class="selectExample"
                  v-model="id_education_background"
                  required
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in educationBackgroundList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.id_education_background.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>

          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>
                  Alamat Korespondensi <br />
                  <small>Alamat Surat Menyurat</small>
                </h1>
                <p>Correspondence Address</p>
              </div>
            </div>
            <div class="col-lg-8 col-md-6">
              <div class="ekyc-form-input">
                <h3>Alamat</h3>
                <p>Address</p>
                <b-row>
                  <b-form-textarea
                    id="correspondence_address"
                    v-model="correspondence_address"
                    rows="3"
                    class="ml-3"
                    max-rows="6"
                    maxlength="100"
                    required
                    autocomplete="off"
                    :disabled="disabledAddress"
                    name="correspondence_address"
                  ></b-form-textarea>
                </b-row>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_address.required"
                >
                  <p>Wajib diisi</p>
                </div>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_address.minLength"
                >
                  <p>
                    Alamat harus memiliki setidaknya
                    {{ $v.correspondence_address.$params.minLength.min }}
                    karakter.
                  </p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md">
              <div class="ekyc-form-input">
                <h3>Negara</h3>
                <p>Country</p>
                <vs-select
                  :disabled="disabledAddress"
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  @input="selectIdCountry($event)"
                  @change="fetchProvinces()"
                  v-model="correspondence_country_code"
                  name="correspondence_country_code"
                  id="correspondence_country_code"
                  style="width: 100%"
                  required
                >
                  <vs-select-item
                    :key="country.id"
                    :value="country.id"
                    :text="country.country_name"
                    v-for="country in countryList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_country_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-6"
              v-if="correspondence_country_code == 130"
            >
              <div class="ekyc-form-input">
                <h3>Propinsi <span>(Opsional)</span></h3>
                <p>Province</p>
                <vs-select
                  :disabled="disabledAddress"
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="correspondence_province_code"
                  @input="selectIdProvince($event)"
                  @change="fetchCities()"
                  name="correspondence_province_code"
                  id="correspondence_province_code"
                  style="width: 100%"
                  required
                >
                  <vs-select-item
                    :key="province.id"
                    :value="province.id"
                    :text="province.province_name"
                    v-for="province in provinceList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_province_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div
              class="col-lg-4 col-md-6"
              v-if="correspondence_country_code == 130"
            >
              <div class="ekyc-form-input">
                <h3>Kota/Kabupaten<span> (Opsional)</span></h3>
                <p>City</p>
                <vs-select
                  :disabled="disabledAddress"
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="correspondence_city_code"
                  name="correspondence_city_code"
                  id="correspondence_city_code"
                  style="width: 100%"
                  required
                >
                  <vs-select-item
                    :key="index"
                    :value="city.city_code"
                    :text="city.city_name"
                    v-for="(city, index) in cityList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_city_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div
              class="col-lg-2 col-md-6"
              v-if="correspondence_country_code == 130"
            >
              <div class="ekyc-form-input">
                <h3>Kode Pos</h3>
                <p>Postal Code</p>
                <vs-input
                  :disabled="disabledAddress"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="number"
                  v-model="correspondence_postal_code"
                  required
                />
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_postal_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>
                  Alamat Sesuai Identitas <br />
                  <small>Alamat sesuai KTP</small>
                </h1>
                <p>Address as Stated in ID</p>
              </div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-radio">
                <vs-radio
                  v-model="isIdentityAddress"
                  vs-name="isIdentityAddress"
                  vs-value="1"
                  @change="checkIdentityIsCorrespondenceAddress"
                  required
                  >Alamat Sesuai Korespondensi<span>
                    / Address as Correspondence Address</span
                  ></vs-radio
                >
                <vs-radio
                  v-model="isIdentityAddress"
                  vs-name="isIdentityAddress"
                  vs-value="2"
                  @change="checkOtherIdentityIsCorrespondenceAddress"
                  >Alamat Lain <span> / Other Address</span></vs-radio
                >
                <div class="error mt-3" v-if="!$v.isIdentityAddress.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <div v-show="isIdentityAddress === '2'">
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-8 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Alamat</h3>
                  <p>Address</p>
                  <b-row>
                    <b-form-textarea
                      id="identity_address"
                      v-model="identity_address"
                      rows="3"
                      class="ml-3"
                      max-rows="6"
                      maxLength="100"
                      required
                      autocomplete="off"
                    ></b-form-textarea>
                  </b-row>
                  <div class="error mt-3" v-if="!$v.identity_address.required">
                    <p>Wajib diisi</p>
                  </div>
                  <div class="error mt-3" v-if="!$v.identity_address.minLength">
                    <p>
                      Alamat harus memiliki setidaknya
                      {{ $v.identity_address.$params.minLength.min }} karakter.
                    </p>
                  </div>
                </div>
              </div>
            </b-row>

            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Negara</h3>
                  <p>Country</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    @input="selectIdCountry($event)"
                    @change="fetchProvinces()"
                    v-model="identity_country_code"
                    name="identity_country_code"
                    id="identity_country_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="country.id"
                      :value="country.id"
                      :text="country.country_name"
                      v-for="country in countryList"
                    />
                  </vs-select>
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_country_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-6"
                v-if="identity_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Propinsi <span>(Opsional)</span></h3>
                  <p>Province</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="identity_province_code"
                    @input="selectIdProvince($event)"
                    @change="fetchCities()"
                    name="identity_province_code"
                    id="identity_province_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="province.id"
                      :value="province.id"
                      :text="province.province_name"
                      v-for="province in provinceList"
                    />
                  </vs-select>
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_province_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div
                class="col-lg-4 col-md-6"
                v-if="identity_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Kota/Kabupaten<span> (Opsional)</span></h3>
                  <p>City</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="identity_city_code"
                    name="identity_city_code"
                    id="identity_city_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="city.city_code"
                      :text="city.city_name"
                      v-for="(city, index) in cityList"
                    />
                  </vs-select>
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_city_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md" v-if="identity_country_code == 130">
                <div class="ekyc-form-input">
                  <h3>Kode Pos</h3>
                  <p>Postal Code</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="identity_postal_code"
                  />
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_postal_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
            </b-row>
          </div>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Alamat Domisili</h1>
                <p>Residential Address</p>
              </div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-radio">
                <vs-radio
                  v-model="isDomicileAddress"
                  vs-name="isDomicileAddress"
                  vs-value="1"
                  @change="checkDomicileIsCorrespondenceAddress"
                  required
                  >Alamat Sesuai Korespondensi<span>
                    / Address as Correspondence Addres</span
                  ></vs-radio
                >
                <vs-radio
                  v-model="isDomicileAddress"
                  vs-name="isDomicileAddress"
                  vs-value="2"
                  @change="checkOtherDomicileIsCorrespondenceAddress"
                  >Alamat Lain <span> / Other Address</span></vs-radio
                >
              </div>
              <div class="error mt-3" v-if="!$v.isDomicileAddress.required">
                <p>Wajib diisi</p>
              </div>
            </div>
          </b-row>
          <div v-show="isDomicileAddress === '2'">
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-8 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Alamat Domisili</h3>
                  <p>Residential Address</p>
                  <b-row>
                    <b-form-textarea
                      id="domicile_address"
                      v-model="domicile_address"
                      rows="3"
                      maxLength="100"
                      class="ml-3"
                      max-rows="6"
                      required
                      autocomplete="off"
                    ></b-form-textarea>
                  </b-row>
                  <div class="error mt-3" v-if="!$v.domicile_address.required">
                    <p>Wajib diisi</p>
                  </div>
                  <div class="error mt-3" v-if="!$v.domicile_address.minLength">
                    <p>
                      Alamat harus memiliki setidaknya
                      {{ $v.domicile_address.$params.minLength.min }} karakter.
                    </p>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-4 col-md">
                <div class="ekyc-form-input">
                  <h3>Negara</h3>
                  <p>Country</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    @input="selectIdCountry($event)"
                    @change="fetchProvinces()"
                    v-model="domicile_country_code"
                    name="domicile_country_code"
                    id="domicile_country_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="country.id"
                      :value="country.id"
                      :text="country.country_name"
                      v-for="country in countryList"
                    />
                  </vs-select>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-6"
                v-if="domicile_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Propinsi <span>(Opsional)</span></h3>
                  <p>Province</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="domicile_province_code"
                    @input="selectIdProvince($event)"
                    @change="fetchCities()"
                    name="domicile_province_code"
                    id="domicile_province_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="province.id"
                      :value="province.id"
                      :text="province.province_name"
                      v-for="province in provinceList"
                    />
                  </vs-select>
                </div>
              </div>
            </b-row>
            <b-row
              class="justify-content-md-start mb-4"
              v-if="domicile_country_code == 130"
            >
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Kota/Kabupaten<span> (Opsional)</span></h3>
                  <p>City</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="domicile_city_code"
                    name="domicile_city_code"
                    id="domicile_city_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="city.city_code"
                      :text="city.city_name"
                      v-for="(city, index) in cityList"
                    />
                  </vs-select>
                </div>
              </div>
              <div
                class="col-lg-2 col-md-6"
                v-if="domicile_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Kode Pos</h3>
                  <p>Postal Code</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="domicile_postal_code"
                  />
                </div>
              </div>
            </b-row>
          </div>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Data Rekening</h1>
                <p>Bank Account</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Nama Bank</h3>
                <p>Bank Name</p>
                <vs-select
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="id_bank_1"
                  name="id_bank_1"
                  id="id_bank_1"
                  style="width: 100%"
                >
                  <vs-select-item
                    :key="index"
                    :value="bank.id"
                    :text="bank.bank_name"
                    v-for="(bank, index) in banks"
                  />
                </vs-select>
                <div class="error mt-3" v-if="!$v.id_bank_1.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Nomor Rekening</h3>
                <p>Account Number</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="number"
                  v-model="payment_acc_number_1"
                  required
                  name="payment_acc_number_1"
                />
                <div
                  class="error mt-3"
                  v-if="!$v.payment_acc_number_1.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Nama Pemilik Rekening</h3>
                <p>Account Name</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="payment_acc_name_1"
                  name="payment_acc_name_1"
                />
                <div class="error mt-3" v-if="!$v.payment_acc_name_1.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-radio">
                <h3>Mata Uang</h3>
                <p>Currency</p>
                <b-row>
                  <div class="col-lg-4 col-md-6">
                    <vs-radio
                      v-model="id_currency_1"
                      vs-name="id_currency_1"
                      vs-value="1"
                      >IDR: Indonesia Rupiah</vs-radio
                    >
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <vs-radio
                      v-model="id_currency_1"
                      vs-name="id_currency_1"
                      vs-value="2"
                      >USD: US Dollar</vs-radio
                    >
                  </div>
                </b-row>
                <div class="error mt-3" v-if="!$v.id_currency_1.required">
                  <p>Wajib diisi</p>
                </div>

                <div v-if="isHidden">
                  <button
                    type="button"
                    class="btn-add-bank py-2 px-4"
                    v-on:click="isHidden = !isHidden"
                  >
                    Tambah Data Rekening
                  </button>
                </div>
              </div>
            </div>
          </b-row>
          <div v-if="isHidden">
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6">
                <div class="register-header text-left">
                  <h1>Data Rekening 2</h1>
                  <p>Bank Account 2</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Nama Bank</h3>
                  <p>Bank Name</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="id_bank_2"
                    name="id_bank_2"
                    id="id_bank_2"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="bank.id"
                      :text="bank.bank_name"
                      v-for="(bank, index) in banks"
                    />
                  </vs-select>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Nomor Rekening</h3>
                  <p>Account Number</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="payment_acc_number_2"
                  />
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6">
                <div class="register-header text-left"></div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Nama Pemilik Rekening</h3>
                  <p>Full Name</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="payment_acc_name_2"
                    disabled
                  />
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6">
                <div class="register-header text-left"></div>
              </div>
              <div class="col-lg-9 col-md-6">
                <div class="ekyc-form-radio">
                  <h3>Mata Uang</h3>
                  <p>Currency</p>
                  <b-row>
                    <div class="col-lg-4 col-md-6">
                      <vs-radio
                        v-model="id_currency_2"
                        vs-name="id_currency_2"
                        vs-value="1"
                        >IDR: Indonesia Rupiah</vs-radio
                      >
                    </div>
                    <div class="col-lg-4 col-md-6">
                      <vs-radio
                        v-model="id_currency_2"
                        vs-name="id_currency_2"
                        vs-value="2"
                        >USD: US Dollar</vs-radio
                      >
                    </div>
                  </b-row>
                  <div v-if="isHidden" class="my-2">
                    <button
                      type="button"
                      class="btn-add-bank py-2 px-4"
                      v-on:click="isHidden = !isHidden"
                    >
                      Tutup
                    </button>
                  </div>
                  <div v-if="!isHidden2">
                    <button
                      type="button"
                      class="btn-add-bank py-2 px-4"
                      v-on:click="isHidden2 = !isHidden2"
                    >
                      Tambah Data Rekening
                    </button>
                  </div>
                </div>
              </div>
            </b-row>
          </div>
          <div v-if="isHidden2">
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6">
                <div class="register-header text-left">
                  <h1>Data Rekening 3</h1>
                  <p>Bank Account 3</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Nama Bank</h3>
                  <p>Bank Name</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="id_bank_3"
                    name="id_bank_3"
                    id="id_bank_3"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="bank.id"
                      :text="bank.bank_name"
                      v-for="(bank, index) in banks"
                    />
                  </vs-select>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Nomor Rekening</h3>
                  <p>Account Number</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="payment_acc_number_3"
                  />
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6">
                <div class="register-header text-left"></div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Nama Pemilik Rekening</h3>
                  <p>Full Name</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="payment_acc_name_3"
                    disabled
                  />
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6">
                <div class="register-header text-left"></div>
              </div>
              <div class="col-lg-9 col-md-6">
                <div class="ekyc-form-radio">
                  <h3>Mata Uang</h3>
                  <p>Currency</p>
                  <b-row>
                    <div class="col-lg-4 col-md-6">
                      <vs-radio
                        v-model="id_currency_3"
                        vs-name="id_currency_3"
                        vs-value="1"
                        >IDR: Indonesia Rupiah</vs-radio
                      >
                    </div>
                    <div class="col-lg-4 col-md-6">
                      <vs-radio
                        v-model="id_currency_3"
                        vs-name="id_currency_3"
                        vs-value="2"
                        >USD: US Dollar</vs-radio
                      >
                    </div>
                  </b-row>
                  <div v-if="isHidden2" class="my-2">
                    <button
                      type="button"
                      class="btn-add-bank py-2 px-4"
                      v-on:click="isHidden2 = !isHidden2"
                    >
                      Tutup
                    </button>
                  </div>
                </div>
              </div>
            </b-row>
          </div>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Informasi Lainnya</h1>
                <p>Other Information</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Tujuan Investasi</h3>
                <p>Investment Objective</p>
                <vs-select
                  class="selectExample"
                  v-model="id_investment_objective"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in investmentObjectiveList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.id_investment_objective.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Sumber Dana Investasi</h3>
                <p>Source of Fund</p>
                <vs-select class="selectExample" v-model="id_source_of_fund">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in sourceOfFundList"
                  />
                </vs-select>
                <div class="error mt-3" v-if="!$v.id_source_of_fund.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Pekerjaan Anda saat ini</h3>
                <p>Your current occupation</p>
                <vs-select class="selectExample" v-model="id_occupation">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in occupationList"
                  />
                </vs-select>
                <div class="error mt-3" v-if="!$v.id_occupation.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="ekyc-form-input">
                <h3>Penghasilan bersih dalam setahun (dalam Rupiah)</h3>
                <p>Annual Net Main Income in Rupiah</p>
                <vs-select class="selectExample" v-model="id_income_level">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in incomeLevelList"
                  />
                </vs-select>
                <div class="error mt-3" v-if="!$v.id_income_level.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
        <div class="col-lg-3 col-md-6"></div>
        <div
          class="col-lg-4 col-md-6"					
        >
          <div class="ekyc-form-input">
            <h3>Nama perusahaan</h3>
            <!-- <p>District</p> -->            
              <input type="text"
                class="mb-2 mr-sm-2 mb-sm-0 form-control"
                v-model="company_name"
                name="company_name">
            <div
              class="error mt-3"
              v-if="!$v.company_name.required"
            >
              <p>Wajib diisi</p>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6"					
        >
          <div class="ekyc-form-input">
            <h3>Pemilik Manfaat</h3>
            <!-- <p>District</p> -->            
              <input type="text"
                class="mb-2 mr-sm-2 mb-sm-0 form-control"
                v-model="beneficiary_name"
                name="beneficiary_name">
            <div
              class="error mt-3"
              v-if="!$v.beneficiary_name.required"
            >
              <p>Wajib diisi</p>
            </div>
          </div>
        </div>
      </b-row>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Persetujuan</h1>
                <p>Agreement</p>
              </div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-input">
                <h3>Upload Foto Kartu Identitas</h3>
                <p>Upload Photo of Your ID Card</p>
                <b-row>
                  <b-col>
                    <template>
                      <div class="dropbox" v-if="!previewKTP">
                        <span class="mb-4">{{ messageKTP }}</span>
                        <div v-if="errorsKTP" class="errors">
                          <p v-for="(error, index) in errorsKTP" :key="index">
                            {{ error }}
                          </p>
                        </div>
                        <p>
                          Drag your file(s) here to begin<br />
                          or click to browse
                        </p>
                        <div>
                          <input
                            type="file"
                            ref="fileKtp"
                            id="file"
                            class="input-file"
                            @change="fileImageKTP"
                            required
                          />
                        </div>
                      </div>
                      <div class="preview text-center" v-if="previewKTP">
                        <img :src="previewKTP" width="320" height="200" />
                        <b-row class="py-2">
                          <b-button
                            class="ml-3 btn-dark"
                            @click="resetImageKTP"
                          >
                            Upload Ulang
                          </b-button>
                        </b-row>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <div class="error mt-3" v-if="!$v.imageKTP.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Upload Swafoto dengan Kartu Identitas</h3>
                <p>Upload your selfie photo with your ID Card</p>
                <b-row>
                  <b-col>
                    <template>
                      <div class="dropbox" v-if="!previewSelfie">
                        <span class="mb-4">{{ messageSelfie }}</span>
                        <div v-if="errorsSelfie" class="errors">
                          <p
                            v-for="(error, index) in errorsSelfie"
                            :key="index"
                          >
                            {{ error }}
                          </p>
                        </div>
                        <p>
                          Drag your file(s) here to begin<br />
                          or click to browse
                        </p>
                        <div>
                          <input
                            type="file"
                            ref="file"
                            id="file"
                            class="input-file"
                            @change="fileImageSelfie"
                            required
                          />
                        </div>
                      </div>
                      <div class="preview text-center" v-if="previewSelfie">
                        <img :src="previewSelfie" width="320" height="200" />
                        <b-row class="py-2">
                          <b-button
                            class="ml-3 btn-dark"
                            @click="resetImageSelfie"
                          >
                            Upload Ulang
                          </b-button>
                        </b-row>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <div class="error mt-3" v-if="!$v.imageSelfie.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="ekyc-form-input">
                <div class="row selfie-instruction">
                  <div class="col-lg-4 col-md-6 mb-2 text-center">
                    <img
                      src="@/assets/img/ekyc/selfie-instruction.svg"
                      alt="selfie-instruction"
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-lg-8 col-md-6">
                    <h3>Panduan Foto</h3>
                    <ol class="ml-3">
                      <li>
                        Pastikan Foto Wajah dan kartu identitas terlihat jelas.
                      </li>
                      <li>Wajah tidak tertutup kartu identitas.</li>
                      <li>Memakai pakaian yang sopan.</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-input">
                <b-row>
                  <div class="col-lg-8 col-md-6">
                    <h3>Tanda Tangan</h3>
                    <p>Signature</p>
                  </div>
                  <div class="col-lg-4 col-md-6 text-right">
                    <b-button class="mt-3 btn-dark" @click="undoSignature">
                      Ulang Tanda Tangan
                    </b-button>
                  </div>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="dropbox-signature">
                      <VueSignaturePad ref="signaturePad" />
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="error mt-3" v-if="!$v.imageSelfie.required">
                <p>Wajib diisi</p>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="row">
                <div class="col-lg-12 col-md-6 d-flex">
                  <div class="align-items-center">
                    <vs-checkbox
                      v-model="agreementChecked"
                      :disabled="agreement"
                    >
                    </vs-checkbox>
                  </div>
                  <div class="mx-2">
                    <p>
                      Saya telah membaca, memahami, dan menyetujui
                      <b-link
                        href="https://invesnow.id/syarat-dan-ketentuan"
                        class="text-danger text-decoration-none"
                        target="_blank"
                        >Syarat dan Ketentuan.</b-link
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-end btn-submit-row mb-4">
            <div class="col-lg-2 col-md-6 text-right">
              <b-button
                block
                type="submit"
                :disabled="!agreementChecked || loading"
                @click.once="handleSubmit()"
                class="btn-tertiary py-2 px-4"
              >
                <div v-if="loading">
                  <div class="spinner-border spinner-border-sm"></div>
                  Loading
                </div>
                <div v-else>Lanjut</div>
              </b-button>
            </div>
          </b-row>
        </b-form>

        <div class="modal-register">
          <template v-if="user.individual.investors_risk_profile !== null && user.individual.investors_risk_profile !== ''">
            <b-modal
              id="checkModal"
              v-model="checkData"
              ref="checkModal"
              size="md"
              class="modal-failed-register"
              centered
              hide-footer
              hide-header
              no-close-on-backdrop
            >
              <div class="d-block text-center">
                <img
                  src="@/assets/img/ekyc/verification-proccess.svg"
                  alt="data-not-correct"
                />
                <h1 class="header-modal p-4 my-2 text-dark">
                  Menunggu Verifikasi Akun
                </h1>
                <p>
                  Mohon tunggu maksimal 2 hari kerja.<br />Setelah itu, Anda
                  bisa mulai investasi.<br />Jangan lupa cek email, ya!
                </p>
                <b-row class="justify-content-md-end btn-submit-row mb-4">
                  <div class="col-lg-12 col-md-6">
                    <b-button
                      size="sm"
                      class="btn-tertiary px-4 py-2"
                      to="/portfolio"
                      >Kembali</b-button
                    >
                  </div>
                </b-row>
              </div>
            </b-modal>
          </template>

          <template v-if="user.individual.ifua !== null && user.individual.ifua !== ''">
            <b-modal
              id="checkModalIfua"
              v-model="checkDataIfua"
              ref="checkModalIfua"
              size="md"
              class="modal-failed-register"
              centered
              hide-footer
              hide-header
              no-close-on-backdrop
            >
              <div class="d-block text-center">
                <img
                  src="@/assets/img/ekyc/verification-proccess.svg"
                  alt="data-not-correct"
                />
                <h1 class="header-modal p-4 my-2 text-dark">
                  Akun Anda Sudah Aktif
                </h1>
                <p>
                  Mohon maaf untuk saat ini Anda tidak bisa mengakses halaman
                  ini<br />Anda bisa mulai investasi.
                </p>
                <b-row class="justify-content-md-end btn-submit-row mb-4">
                  <div class="col-lg-12 col-md-6">
                    <b-button
                      size="sm"
                      class="btn-tertiary px-4 py-2"
                      to="/portfolio"
                      >Kembali</b-button
                    >
                  </div>
                </b-row>
              </div>
            </b-modal>
          </template>

          <template v-else> </template>

		<b-modal
			id="modal-failed-register"
			v-model="sizeKtpImg"
			size="md"
			class="modal-failed-register"
			centered
			hide-footer>
			<div class="d-block text-center">
				<img
					src="@/assets/img/ekyc/data-not-correct.svg"
					alt="data-not-correct"
				/>
				<h1 class="header-modal p-4 my-2 text-dark">
					Ukuran Foto Terlalu Besar
				</h1>
				<p>Maksimal ukuran foto 6MB</p>              
			</div>
		</b-modal>

          <b-modal
            id="modal-failed-register"
            v-model="failedShow"
            size="md"
            class="modal-failed-register"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img
                src="@/assets/img/ekyc/data-not-correct.svg"
                alt="data-not-correct"
              />
              <h1 class="header-modal p-4 my-2 text-dark">
                Isian belum sesuai
              </h1>
              <p>Cek kembali form yang anda isi</p>
              <!-- <p>{{errorMessage}}</p> -->
            </div>
          </b-modal>

          <b-modal
            id="modal-correspondence"
            v-model="failedCorrespondence"
            size="md"
            class="modal-correspondence"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img
                src="@/assets/img/ekyc/data-not-correct.svg"
                alt="data-not-correct"
              />
              <h1 class="header-modal p-4 my-2 text-dark">
                Alamat belum lengkap
              </h1>
              <p>
                Cek kembali detail isian alamat Korespondensi, domisili,
                identitas seperti address, negara, provinsi, kota, dan kode pos
              </p>
            </div>
          </b-modal>

          <b-modal
            id="modal-correspondence"
            v-model="failedDateOfBirth"
            size="md"
            class="modal-correspondence"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img
                src="@/assets/img/ekyc/data-not-correct.svg"
                alt="data-not-correct"
              />
              <h1 class="header-modal p-4 my-2 text-dark">
                Tanggal lahir tidak boleh lebih dari tanggal hari ini
              </h1>
              <p>Cek kembali form yang anda isi</p>
            </div>
          </b-modal>
        </div>
      </b-container>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/partials/header/Header.vue";
import Footer from "@/components/partials/footer/Footer.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import { required, minLength } from "vuelidate/lib/validators";
import moment from "moment";

let currentDate = moment().format("YYYYMMDD");

const instance = axios.create({
  withCredentials: true,
});

export default {
  name: "OpeningAccount",
  metaInfo: {
    title: "Pembukaan Akun | Invesnow.id",
  },
  components: {
    Header,
    Footer,
  },
  validations: {
    first_name: {
      required,
      minLength: minLength(3),
    },
    country_code: {
      required,
    },
    id_type: {
      required,
    },
    no_id: {
      required,
      minLength: minLength(16),
    },
    place_of_birth: {
      required,
      minLength: minLength(3),
    },
    date_of_birth: {
      required,
    },
    id_gender: {
      required,
    },
    id_marital_status: {
      required,
    },
    id_religion: {
      required,
    },
    id_education_background: {
      required,
    },
    correspondence_address: {
      required,
      minLength: minLength(3),
    },
    correspondence_city_code: {
      required,
    },
    correspondence_province_code: {
      required,
    },
    correspondence_country_code: {
      required,
    },
    correspondence_postal_code: {
      required,
    },
    isIdentityAddress: {
      required,
    },
    identity_address: {
      required,
      minLength: minLength(3),
    },
    domicile_address: {
      required,
      minLength: minLength(3),
    },
    identity_province_code: {
      required,
    },
    identity_country_code: {
      required,
    },
    identity_city_code: {
      required,
    },
    identity_postal_code: {
      required,
    },
    isDomicileAddress: {
      required,
    },
    id_investment_objective: {
      required,
    },
    id_source_of_fund: {
      required,
    },
    id_occupation: {
      required,
    },
    id_income_level: {
      required,
    },
    id_bank_1: {
      required,
    },
    payment_acc_number_1: {
      required,
    },
    payment_acc_name_1: {
      required,
    },
    id_currency_1: {
      required,
    },
    imageKTP: {
      required,
    },
    imageSelfie: {
      required,
    },
    spouse_name:{
      required
    },
    mother_name:{
      required
    },
    company_name:{
      required
    },
    beneficiary_name:{
      required
    }
  },
  data() {
    return {
      spouse_name:null,
      mother_name:null,
      company_name:null,
      beneficiary_name:null,
      religionList: [
        { value: null, text: "Pilih", disabled: true },
        { value: "1", text: "Islam / Islam" },
        { value: "2", text: "Protestan / Protestant" },
        { value: "3", text: "Katolik / Catholic" },
        { value: "4", text: "Hindu  / Hinduism" },
        { value: "5", text: "Buddha / Budhism" },
        { value: "6", text: "Konghucu / Confucianinsm" },
        { value: "7", text: "Lainnya / Others" },
      ],

      educationBackgroundList: [
        { value: null, text: "Pilih", disabled: true },
        { value: "1", text: "SD / Primary School" },
        { value: "2", text: "SMP  / Junior High School" },
        { value: "3", text: "SMA  / Senior High School" },
        { value: "4", text: "D3 / Diploma" },
        { value: "5", text: "S1 / Undergraduate" },
        { value: "6", text: "S2 / Postgraduate" },
        { value: "7", text: "S3 / Doctoral Program" },
        { value: "8", text: "Lainnya  / Others" },
      ],

      sourceOfFundList: [
        { value: null, text: "Pilih", disabled: true },
        { value: "1", text: "Gaji / Salary" },
        { value: "2", text: "Hasil Usaha / Business Profit" },
        { value: "3", text: "Bunga Simpanan / Saving Interest" },
        { value: "4", text: "Warisan / Legacy" },
        { value: "5", text: "Orang Tua/Anak  / Parents/Children" },
        { value: "6", text: "Hibah / Grant" },
        { value: "7", text: "Suami/Istri / Husband/Wife" },
        { value: "8", text: "Undian / Drawing" },
        { value: "9", text: "Hasil Investasi  / Investment Gain" },
        { value: "10", text: "Lainnya / Others" },
      ],

      investmentObjectiveList: [
        { value: null, text: "Pilih", disabled: true },
        {
          value: "1",
          text: "Mendapatkan Kenaikan Harga / Gain From Capital Margin",
        },
        { value: "2", text: "Investasi / Investment" },
        { value: "3", text: "Spekulasi / Speculation" },
        { value: "4", text: "Mendapatkan Penghasilan / Income" },
        { value: "5", text: "Lainnya  / Others" },
      ],

      occupationList: [
        { value: null, text: "Pilih", disabled: true },
        { value: "1", text: "Pelajar/Mahasiswa  / Student" },
        { value: "2", text: "Ibu Rumah Tangga / Housewife" },
        { value: "3", text: "Wiraswasta / Enterpreneur" },
        { value: "4", text: "Pegawai Negri / Civil Servant" },
        { value: "5", text: "TNI/Polisi / Law Enforcement" },
        { value: "6", text: "Pensiunan / Retirement" },
        { value: "7", text: "Guru/Dosen  /Lecture/Teacher" },
        { value: "8", text: "Pegawai Swasta / Private Employee" },
        { value: "9", text: "Lainnya / Others" },
      ],

      incomeLevelList: [
        { value: null, text: "Pilih", disabled: true },
        { value: "1", text: "< Rp.10 Juta / < 10 milion/year" },
        { value: "2", text: "> Rp.10-50 Juta / > 10-50 milion/year" },
        { value: "3", text: "> Rp.50-100 Juta<span / > 50-100 milion/year" },
        {
          value: "4",
          text: "> Rp.100 Juta - 500 Juta / > 100-500 milion milion/year",
        },
        {
          value: "5",
          text: "> Rp.500 Juta - 1 Miliar / > 500 milion - 1 billion",
        },
        { value: "6", text: "> 1 Miliar / > 1 billion/year" },
      ],
	//validate size image
	sizeKtpImg:false,
      // Production
      email: "",
      mobile_phone: "",
      first_name: "",
      id_gender: "",
      country_code: "ID",
      countries: [],
      country: [],
      id_type: "",
      no_id: "",
      id_marital_status: "",
      id_religion: null,
      place_of_birth: "",
      country_of_birth: null,
      date_of_birth: "",
      id_education_background: null,
      identity_address: "",
      identity_province_code: null,
      provinces: [],
      province: [],
      domicile_provinces: [],
      domicile_province: [],
      correspondence_provinces: [],
      correspondence_province: [],
      identity_country_code: null,
      identity_city_code: null,
      cities: [],
      city: [],
      domicile_cities: [],
      domicile_city: [],
      correspondence_cities: [],
      correspondence_city: [],
      identity_postal_code: "",
      domicile_address: "",
      domicile_country_code: null,
      domicile_province_code: null,
      domicile_city_code: null,
      domicile_postal_code: null,
      correspondence_address: "",
      correspondence_country_code: null,
      correspondence_province_code: null,
      correspondence_city_code: null,
      correspondence_postal_code: "",
      id_investment_objective: null,
      id_source_of_fund: null,
      id_investor_risk_profile: "1",
      id_occupation: null,
      id_income_level: null,
      banks: [],
      bank: [],
      id_bank_1: null,
      payment_acc_number_1: "",
      payment_acc_name_1: "",
      id_currency_1: "",
      id_bank_2: "",
      payment_acc_number_2: "",
      payment_acc_name_2: "",
      id_currency_2: "",
      id_bank_3: "",
      payment_acc_number_3: "",
      payment_acc_name_3: "",
      id_currency_3: "",
      expiration_date_id: "",
      bank_branch_1: "",

      sa_code: "INV69",

      id_statement_type: "2",
      agreementChecked: false,
      expChecked: true,
      failedShow: false,
      failedCorrespondence: false,
      failedDomicile: false,
      failedIdentity: false,
      failedDateOfBirth: false,
      errorMessage: false,
      isIdentityAddress: "",
      isDomicileAddress: "",
      isHidden: false,
      isHidden2: false,
      isHiddenDomicile: "",
      loading: false,

      imageKTP: null,
      messageKTP: null,
      previewKTP: null,
      errorsKTP: null,
      imageSelfie: null,
      base64Selfie: null,
      base64KTP: null,
      messageSelfie: null,
      previewSelfie: null,
      errorsSelfie: null,
      disabled: false,
      disabledAddress: false,
      agreement: true,
      seen: true,
      processing: false,
      selectedIdCountry: "",
      selectedIdProvince: "",
    };
  },
  mounted() {
    this.fetchCountries();
    this.fetchProvinces();
    this.fetchCities();
    this.fetchBanks();
    this.checkData();
    this.checkDataIfua();
    if (localStorage.first_name) {
      this.first_name = localStorage.first_name;
    }
    this.email = this.user.individual.email;
  },
  watch: {
    first_name(newName) {
      localStorage.first_name = newName;
    },
  },
  computed: {
    ...mapGetters({
      bearer_token: "bearer_token",
      check: "auth/check",
      user: "auth/user",
      access_token: "auth/access_token",
    }),
    base64Signature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log("isEmpty", isEmpty);
      return data;
    },
    countryList() {
      return this.countries
        .concat()
        .sort((a, b) => a.country_name.localeCompare(b.country_name));
    },
    provinceList() {
      return this.provinces
        .concat()
        .sort((a, b) => a.province_name.localeCompare(b.province_name));
    },
    cityList() {
      return this.cities
        .concat()
        .sort((a, b) => a.city_name.localeCompare(b.city_name));
    },
    // provinceList: function() {
    //   function compare(a, b) {
    //     if (a.province_name < b.province_name)
    //       return -1;
    //     if (a.province_name > b.province_name)
    //       return 1;
    //     return 0;
    //   }

    //   return this.provinces.sort(compare);
    // },
    // cityList: function() {
    //   function compare(a, b) {
    //     if (a.city_name < b.city_name)
    //       return -1;
    //     if (a.city_name > b.city_name)
    //       return 1;
    //     return 0;
    //   }

    //   return this.cities.sort(compare);
    // },
  },
  methods: {
    fillName() {
      this.payment_acc_name_1 = this.first_name;
    },
    selectIdCountry(e) {
      this.selectedIdCountry = e;
    },
    selectIdProvince(e) {
      this.selectedIdProvince = e;
    },
    checkData() {
      this.$refs["checkModal"].show();
    },
    checkDataIfua() {
      this.$refs["checkModalIfua"].show();
    },
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },
    fileImageKTP(event) {
        const maxSize = 6266467;
        this.imageKTP = event.target.files[0];
        this.previewKTP = URL.createObjectURL(event.target.files[0]);
        console.log('img size:' + this.imageKTP.size);
        if (this.imageKTP.size > maxSize) {
            this.sizeKtpImg = true;
            this.imageKTP = '';
            this.previewKTP= '';
            this.$refs.fileKtp.value = null;
        }
    },
    resetImageKTP() {
      this.imageKTP = "";
      this.previewKTP = "";
    },
    fileImageNPWP(event) {
		const maxSize = 6266467;
      this.imageNPWP = event.target.files[0];
      this.previewNPWP = URL.createObjectURL(event.target.files[0]);

	if (this.imageNPWP.size > maxSize) {
			this.sizeKtpImg = true;
			this.imageNPWP = '';
      this.previewNPWP= '';
      this.$refs.file.value = null;
		}
    },
    resetImageNPWP() {
      this.imageNPWP = "";
      this.previewNPWP = "";
    },
    fileImageSelfie(event) {
		const maxSize = 6266467;
      this.imageSelfie = event.target.files[0];
      this.previewSelfie = URL.createObjectURL(event.target.files[0]);

	if (this.imageSelfie.size > maxSize) {
			this.sizeKtpImg = true;
			this.imageSelfie = '';
    this.previewSelfie= '';
	this.$refs.file.value = null;
		}
    },
    resetImageSelfie() {
      this.imageSelfie = "";
      this.previewSelfie = "";
    },
    checkId() {
      if (event.target.checked) {
        this.expiration_date_id = "9999-12-31";
        this.disabled = true;
      } else {
        this.disabled = false;
        this.expiration_date_id = "";
      }
    },
    unCheckId() {
      if (event.target.checked) {
        this.expiration_date_id = "";
        this.disabled = false;
      } else {
        this.disabled = true;
        this.expiration_date_id = "9999-12-31";
      }
    },
    checkIdentityIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.identity_address = this.correspondence_address;
        this.identity_city_code = this.correspondence_city_code;
        this.identity_province_code = this.correspondence_province_code;
        this.identity_country_code = this.correspondence_country_code;
        this.identity_postal_code = this.correspondence_postal_code;
        this.agreement = false;
        this.disabledAddress = true;
      } else {
        this.disabledAddress = false;
        this.agreement = true;
        this.identity_address = "";
        this.identity_city_code = "";
        this.identity_province_code = "";
        this.identity_country_code = "";
        this.identity_postal_code = "";
      }
    },
    checkOtherIdentityIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.disabledAddress = false;
        this.agreement = false;
        if (this.identity_country_code === 130) {
          this.identity_address = "";
          this.identity_city_code = "";
          this.identity_province_code = "";
          this.identity_country_code = 130;
        } else {
          this.identity_address = "";
          this.identity_city_code = 9999;
          this.identity_country_code = "";
        }
      }
    },
    checkDomicileIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.domicile_address = this.correspondence_address;
        this.domicile_city_code = this.correspondence_city_code;
        this.domicile_province_code = this.correspondence_province_code;
        this.domicile_country_code = this.correspondence_country_code;
        this.domicile_postal_code = this.correspondence_postal_code;
        this.agreement = false;
        this.disabledAddress = true;
      } else {
        this.disabledAddress = false;
        this.agreement = true;
        this.domicile_address = "";
        this.domicile_city_code = "";
        this.domicile_province_code = "";
        this.domicile_country_code = "";
        this.domicile_postal_code = "";
      }
    },
    checkOtherDomicileIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.disabledAddress = false;
        this.agreement = false;
        if (this.domicile_country_code === 130) {
          this.domicile_address = "";
          this.domicile_city_code = "";
          this.domicile_province_code = "";
          this.domicile_country_code = 130;
        } else {
          this.domicile_address = "";
          this.domicile_city_code = 9999;
          this.domicile_country_code = "";
        }
      }
    },
    async fetchCountries() {
      let response = await axios({
        method: "GET",
        url: "countries",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      this.countries = response.data.data;
    },
    async fetchProvinces() {
      let response = await axios({
        method: "GET",
        url: `provinces?country_id=${this.selectedIdCountry}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      this.provinces = response.data.data;
    },
    async fetchCities() {
      let response = await axios({
        method: "GET",
        url: `cities?province_id=${this.selectedIdProvince}`,
        headers: {},
      });
      this.cities = response.data.data;
    },
    async fetchBanks() {
      let response = await axios({
        method: "GET",
        url: "banks",
        headers: {},
      });
      this.banks = response.data.data;
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.save(formData, fieldName);
    },
    undoSignature() {
      this.$refs.signaturePad.undoSignature();
    },

    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
    },
    handleSubmit() {
      if (this.correspondence_address == "") {
        this.failedCorrespondence = true;
      }

      if (this.correspondence_city_code == null) {
        this.failedCorrespondence = true;
      }

      if (this.correspondence_country_code == null) {
        this.failedCorrespondence = true;
      }

      if (this.correspondence_postal_code == "") {
        this.failedCorrespondence = true;
      }

      let data = new FormData();
      data.append("name", this.first_name);
      data.append("email", this.email);

      let new_date_of_birth = this.date_of_birth.replace(/-/g, "");

      if (new_date_of_birth > currentDate) {
        this.failedDateOfBirth = true;
      }

      let formData = new FormData();
      // formData.append("path_id", this.base64KTP);
      // formData.append("path_signature", this.base64Signature);
      // formData.append("path_selfie", this.base64Selfie);

      formData.append("path_id", this.imageKTP);
      formData.append("path_signature", this.base64Signature);
      formData.append("path_selfie", this.imageSelfie);
      formData.append("id_type", this.id_type);
      formData.append("sa_code", this.sa_code);
      formData.append("first_name", this.first_name);
      formData.append("country_code", this.country_code);
      formData.append("no_id", this.no_id);
      formData.append("expiration_date_id", this.expiration_date_id);
      formData.append("country_of_birth", this.country_code);
      formData.append("place_of_birth", this.place_of_birth);
      formData.append("date_of_birth", new_date_of_birth);
      formData.append("id_gender", this.id_gender);
      formData.append("id_education_background", this.id_education_background);
      formData.append("id_religion", this.id_religion);
      formData.append("id_occupation", this.id_occupation);
      formData.append("id_income_level", this.id_income_level);
      formData.append("id_marital_status", this.id_marital_status);
      formData.append(
        "id_investor_risk_profile",
        this.id_investor_risk_profile
      );
      formData.append("id_investment_objective", this.id_investment_objective);
      formData.append("id_source_of_fund", this.id_source_of_fund);
      formData.append("identity_city_code", this.identity_city_code);
      formData.append("identity_address", this.identity_address);
      formData.append("identity_postal_code", this.identity_postal_code);
      formData.append("domicile_city_code", this.domicile_city_code);
      formData.append("domicile_address", this.domicile_address);
      formData.append("domicile_postal_code", this.domicile_postal_code);
      formData.append("domicile_country_code", this.domicile_country_code);
      formData.append(
        "correspondence_city_code",
        this.correspondence_city_code
      );
      formData.append("correspondence_address", this.correspondence_address);
      formData.append(
        "correspondence_postal_code",
        this.correspondence_postal_code
      );
      formData.append(
        "correspondence_country_code",
        this.correspondence_country_code
      );
      formData.append("mobile_phone", this.user.individual.mobile_phone);
      formData.append("email", this.user.individual.email);
      formData.append("id_statement_type", this.id_statement_type);
      formData.append("id_bank_1", this.id_bank_1);
      formData.append("bank_branch_1", this.bank_branch_1);
      formData.append("id_currency_1", this.id_currency_1);
      formData.append("payment_acc_number_1", this.payment_acc_number_1);
      formData.append("payment_acc_name_1", this.payment_acc_name_1);
      
      // new            
      formData.append("spouses_name",this.spouse_name);
      formData.append("mothers_maiden_name",this.mother_name);
      formData.append("occupation_name",this.company_name);
      formData.append("beneficial_owner",this.beneficiary_name);   

      // formData.append("id_bank_2", this.id_bank_2);
      // formData.append("bank_branch_2", this.bank_branch_1);
      // formData.append("id_currency_2", this.id_currency_2);
      // formData.append("payment_acc_number_2", this.payment_acc_number_2);
      // formData.append("payment_acc_name_2", this.payment_acc_name_2);
      // formData.append("id_bank_3", this.id_bank_3);
      // formData.append("bank_branch_3", this.bank_branch_1);
      // formData.append("id_currency_3", this.id_currency_3);
      // formData.append("payment_acc_number_3", this.payment_acc_number_3);
      // formData.append("payment_acc_name_3", this.payment_acc_name_3);
      formData.append(
        "user_id",
        this.user.individual.user_id || this.user.institutional.user_id
      );
      formData.append(
        "id",
        this.user.individual.id || this.user.institutional.id
      );
      // console.log(formData);
      // return false;
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }      
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${this.access_token}`,
        },
      };

      instance
        .post("ekyc-individual-post", formData, axiosConfig)
        .then((res) => {
          console.log("AXIOS SUCCESS: ", res);
          this.loading = !false;

          window.setTimeout(function () {
            window.location.href = "/profil-resiko";
          }, 2000);
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.failedShow = true;

          // this.errorMessage = err.response.data.data.message;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.register-header-container {
  padding-top: 120px;
  padding-bottom: 40px;
}

.register-header-row {
  text-align: left !important;
}

.register-form {
  background: #f3f4f6;
}
.register-form-container {
  padding-top: 40px;
  padding-bottom: 60px;
}

h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  color: #111827;
}

h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #111827;
}

p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #4b5563;
}

span {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #4f566b;
}

.error {
  p {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #e53e3e !important;
  }
}

.register-header h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #111827;
}
.register-header p {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #6b7280;
}

.mx-input {
  height: 38px !important;
}

.mx-input:hover,
.mx-input:focus {
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
}

.vs-con-input-label {
  width: 100%;
}

.con-select {
  width: 100%;
  clear: both;
}

.con-vs-radio {
  justify-content: start;
}

.con-vs-checkbox {
  justify-content: start;
  margin: 0;
}

.ekyc-form-input h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #111827;
}

.ekyc-form-input p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #6b7280;
}

.ekyc-form-input span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #9ca3af;
}

.ekyc-form-radio span {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #6b7280;
}

.ekyc-form-radio h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #374151;
}

.ekyc-form-radio p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #9ca3af;
}

.ekyc-form-fatcha p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #374151;
}

.residental-address-checkbox h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #374151;
}

.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 100%;
}

.form-control:focus {
  outline: none !important;
  border: 1px solid !important;
  box-shadow: none !important;
}

.radio {
  position: relative;
  input[type="radio"] {
    opacity: 0;
  }
  label {
    padding-left: 10px;
    cursor: pointer;
    margin-bottom: 7px !important;
    &:before {
      width: 18px;
      height: 18px;
      position: absolute;
      top: 1px;
      left: 0;
      content: "";
      display: inline-block;
      -moz-border-radius: 50px;
      -webkit-border-radius: 50px;
      border-radius: 50px;
      border: 1px solid $secondaryColor;
      background: white;
    }
  }
  input[type="radio"] {
    margin: 0px;
    &:disabled + label {
      color: #999;
      &:before {
        background-color: $secondaryColor;
      }
    }
    &:checked + label::after {
      content: "";
      position: absolute;
      top: 5px;
      left: 4px;
      display: inline-block;
      font-size: 11px;
      width: 10px;
      height: 10px;
      background-color: $secondaryColor;
      -moz-border-radius: 50px;
      -webkit-border-radius: 50px;
      border-radius: 50px;
    }
  }
}

.radio-default input[type="radio"]:checked + label:before {
  border-color: $secondaryColor;
}

.ekyc-form-radio input[type="radio"]:checked + label {
  &:before {
    border-color: $secondaryColor;
  }
  &::after {
    background-color: $secondaryColor;
  }
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: $secondaryColor;
}

.custom-checkbox:active {
  box-shadow: none !important;
}
.custom-checkbox:focus {
  box-shadow: none !important;
}

.custom-control-label {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #111827;
}

.jumbotron {
  padding: 0;
  background-color: white;
  opacity: 1;
}

.modal-register {
  z-index: 99999;
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    text-align: center;
    color: black;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    text-align: center;
    color: #4b5563;
  }
}

.btn-add-bank {
  font-family: $inter;
  background: transparent;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  color: #3f0975;
  border: 1px solid #3f0975;
  border-radius: 6px;
}

.btn-tertiary:disabled {
  cursor: no-drop;
}

.btn-dark:focus {
  box-shadow: none !important;
}

.dropbox {
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  top: 200; /* minimum height */
  position: relative;
  border-radius: 5px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  cursor: pointer;
}

.dropbox:hover {
  outline: 2px dashed grey; /* the dash box */ /* when mouse over to the drop zone, change color */
}

.dropbox p {
  position: relative;
  font-size: 1.2em;
  text-align: center;
  top: 50px;
}

.dropbox-signature {
  background: white;
  height: 200px;
  border-radius: 5px;
}
.dropbox-signature:hover {
  outline: 2px dashed grey; /* the dash box */
}

.selfie-instruction {
  margin-top: 64px;
}

@media only screen and (max-width: 768px) {
  .register-header-row {
    text-align: center !important;
  }
  .btn-dark {
    margin-bottom: 18px;
  }
  .btn-submit-row {
    justify-content: center !important;
  }
  .header-modal {
    font-size: 16px !important;
  }
  .selfie-instruction {
    margin-top: 0px;
  }
}
</style>